import { render, staticRenderFns } from "./CommunityUpload.vue?vue&type=template&id=3f79bf74&scoped=true"
import script from "./CommunityUpload.vue?vue&type=script&lang=js"
export * from "./CommunityUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f79bf74",
  null
  
)

export default component.exports